export const isAuthenticatedUser = (
  user: TurnipExchange.User,
): user is TurnipExchange.AuthenticatedUser => user.type === 'authenticated'

export const isAnonymousUser = (user: TurnipExchange.User): user is TurnipExchange.AnonymousUser =>
  user.type === 'anonymous'

export const isBannedUser = (user: TurnipExchange.User): user is TurnipExchange.BannedUser =>
  user.type === 'banned'

export const isAdmin = (user: TurnipExchange.User): boolean =>
  isAuthenticatedUser(user) && !!user.roles?.includes('admin')

export const isModerator = (user: TurnipExchange.User): boolean =>
  isAuthenticatedUser(user) && !!user.roles?.includes('moderator')

export const isUnlocked = (user: TurnipExchange.User): boolean =>
  isAuthenticatedUser(user) && !!user.roles?.includes('unlocked')
